import { IDisplayCard } from 'interfaces/IDisplayCard';

class CardDisplayModel {
  private card: any;

  constructor(card: IDisplayCard) {
    this.card = card;
  }

  get isHovered(): boolean {
    return this.card.isHovered;
  }

  hover(): void {
    this.card.hover();
  }

  leave(): void {
    this.card.leave();
  }

  get isSearchPage() {
    return this.card.page === 'search';
  }

  get isCabinetPage() {
    return this.card.page === 'cabinet';
  }
}

export default CardDisplayModel;
